import { Service } from '@roc/feature-app-core';

const url = {
  GET_PUBLIC_BORROWER_DETAILS_VERIFICATION: '/api/v1/loan/public/borrowerSetup/getPublicBorrowerDetailsVerification',
  INVALID_SSN: '/api/v1/loan/public/borrowerSetup/getInvalidSSN'
};

export class PublicBorrowerSetupToDoService extends Service {

  getBorrowerDetailsVerification(requestToken: string) {
    return this.get(url.GET_PUBLIC_BORROWER_DETAILS_VERIFICATION, { requestToken });
  }

  getInvalidSSN() {
    return this.get(url.INVALID_SSN, { });
  }
}
